import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import https from "https";
import axios from "axios";
import log from "../utils/log";
import useAuthStore from "../states/useAuth";
import useSignUpStore from "../states/useSignUp";
import metaData from "../data/metaData";
import resetAllStores from "../states/resetAllStore";
import c from "../utils/common";

const useAuth = () => {
  const { auth, user, updateAuth, updateUser, updateIsResetTwoFa } = useAuthStore();
  const { updateNewUser } = useSignUpStore();
  const history = useHistory();

  const createAccount = async ({ email, password, tel, secret, permission }) => {
    //format
    email = email.trim();
    password = password.trim();

    let data = {
      name: email,
      email,
      password,
      tel,
      secret,
      permission,
    };
    log.debug(data);

    let res = await axios.post(metaData.serverURL + "merchantUser/signUp", data, {
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    log.debug(res);

    let { user, token } = res.data;
    if (!user?.role || !token) {
      throw new Error("token / role is missing");
    }

    updateAuth({ passed: true, jwt: token, role: user.role });
    updateUser("whole", user);
    //clear newUser after create account
    updateNewUser("whole", undefined);
    return res.data;
  };

  const isEmailExist = async (email) => {
    //format
    email = email.trim();
    let body = { isDisable: false, email: email };

    let res = await axios.post(metaData.serverURL + "merchantUser/isEmailExist", body, {
      httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }),
    });
    log.debug(res);
    // if user not found, will already throw error
    return true;
  };

  const addTwoFa = async (secret) => {
    let url = user.role;
    let query = `?isDisable=false&id=${user.id}`;

    let res = await axios.patch(
      metaData.serverURL + url + query,
      { secret },
      { headers: { Authorization: auth.jwt }, httpsAgent: new https.Agent({ keepAlive: true, keepAliveMsecs: 60000 }) }
    );
    log.debug(res);
    updateIsResetTwoFa(false);
    return true;
  };

  //
  const signOut = async () => {
    await resetAllStores();
    // history.push("/login");
  };

  return { createAccount, isEmailExist, addTwoFa, signOut };
};

export default useAuth;
